/**
 * Quale passo manca davvero prima di poter iniziare la prova gratuita, e cosa scrivere di
 * conseguenza sotto il pulsante.
 *
 * Perché esiste (devops #316). A utente non autenticato il checkout mostrava «INIZIA LA PROVA
 * GRATUITA» disabilitato con sotto «Per proseguire, devi accettare i termini e le condizioni»:
 * due bugie in fila. I termini non erano il passo mancante — in cima alla stessa schermata ci
 * sono ancora Accedi e Registrati — e il pulsante non era premibile, quindi nessuno arrivava al
 * Passo 2 nonostante `handleFreeTrial` sappia portarcelo da sempre.
 *
 * L'ordine dei controlli è quello vero: prima i posti, poi l'accesso, poi i consensi. Spuntare
 * cinque caselle per scoprire solo dopo di non essere loggati è il percorso che la segnalazione
 * descrive come «confonde tantissimo».
 */

export const CTA_PROVA_GRATUITA = 'INIZIA LA PROVA GRATUITA';
export const CTA_ACCEDI = 'ACCEDI O REGISTRATI PER CONTINUARE';
export const AIUTO_ACCESSO = 'Per iniziare la prova gratuita devi prima accedere o registrarti.';

/**
 * @param {object} stato
 * @param {boolean} stato.userLogged      sessione attiva
 * @param {boolean} stato.hasAcceptedTerms tutti e cinque i consensi spuntati
 * @param {boolean} stato.soldOut          posti esauriti per la prova gratuita
 * @returns {{step: 'soldOut'|'auth'|'consents'|'ready', label: string, help: string|null}}
 */
export function freeTrialCtaState({ userLogged = false, hasAcceptedTerms = false, soldOut = false } = {}) {
    if (soldOut) {
        // Senza posti non c'è niente a cui iscriversi: invitare ad accedere sarebbe un giro a
        // vuoto. Il perché lo dice già l'avviso sui posti disponibili, qui non si ripete.
        return { step: 'soldOut', label: CTA_PROVA_GRATUITA, help: null };
    }
    if (!userLogged) {
        return { step: 'auth', label: CTA_ACCEDI, help: AIUTO_ACCESSO };
    }
    if (!hasAcceptedTerms) {
        // L'avviso sui termini resta nel template: contiene il link che riporta alle caselle.
        return { step: 'consents', label: CTA_PROVA_GRATUITA, help: null };
    }
    return { step: 'ready', label: CTA_PROVA_GRATUITA, help: null };
}
